module.exports = __webpack_public_path__ + "static/media/ic_ci_d1_myway.98be204a.svg";